import React, { useEffect, useState, Fragment, useCallback } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import GroupTitle from './GroupTitle/index';
// import ButtonGroupStatusFilter from '../../../../Layout/AppMain/ButtonGroupStatusFilter';
import api from '../../../../services/api';
import Receivers from './ReceiversList';
import {
    TabContent,
    TabPane,
    Row,
    Col,
    Card,
    Button,
    UncontrolledTooltip,
} from 'reactstrap';
import { Elastic } from 'react-burgers';
import classnames from 'classnames';
import cx from 'classnames';
import { useAuth } from '../../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';

import Calendar from './Calendar/index';
import AddNeeds from '../../../../Layout/AppMain/AddNeeds';
import MaterialsList from '../../../../Layout/AppMain/MaterialsList';
import GiftsList from './PlanList/index';
import GroupInfo from '../../../../Layout/AppMain/GroupInfo';
import Needs from './NeedsList';
import ButtonGroupTopActions from '../../../../Layout/AppMain/ButtonGroupTopActions';
import Coordinators from './CoordinatorsList/index';
import Resources from '../../../../Layout/AppMain/Resources';

export default function GiversDetails({ id }) {
    const { toggleLoading, authenticated, setCurrentScript } = useAuth();
    const [group, setGroup] = useState({});
    const [groupId] = useState({ id: id });
    const [activeTab, setActiveTab] = useState('5');
    const [active, setActive] = useState(false);
    const [refreshNeed, setRefreshNeed] = useState(false);
    const [triggerLogCall, setTriggerLogCall] = useState(false);
    const [triggerLogCallEvent, setTriggerLogCallEvent] = useState(false);
    const [seniorsCount, setSeniorsCount] = useState('');

    const [receivers, setReceivers] = useState([]);
    const [allPlans, setAllPlans] = useState([]);
    const [newUser] = useState(null);

    const [currentStatusFilter, setCurrentStatusFilter] = useState({
        id: '',
        label: 'Select',
    });

    const [role] = useState(localStorage.getItem('@Reachout:groupRole'));

    const getGroup = useCallback(() => {
        toggleLoading(true);
        api.get(`/ro.team.getGroup/${id}`)
            .then((response) => {
                setGroup(response.data);
                if (response.data.script) {
                    setCurrentScript(response.data.script);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, id, setCurrentScript]);

    useEffect(() => {
        getGroup();

        const userInfo = () => {
            if (authenticated.user) {
                return authenticated.user;
            } else {
                return authenticated;
            }
        }

        api.post(`/ro.team.listGiverToReceiverForGiver/${groupId.id}`)
            .then((response) => {
                setReceivers(response.data.items);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });

        api.post(`/ro.team.listGiverPlanGift/${groupId.id}`, {
            giverId: userInfo().id
        })
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setAllPlans(response.data);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [getGroup, groupId.id, setReceivers, authenticated]);

    const toggleStatusFilter = useCallback(
        (status) => {
            if (status === null) {
                setCurrentStatusFilter({ id: '', label: 'Select' });
            } else {
                setCurrentStatusFilter(status);
            }
        },
        [setCurrentStatusFilter]
    );

    const toggle = useCallback(
        async (value) => {
            if (active) {
                setActive(!active);
            }
            setActiveTab(value);
            toggleStatusFilter(null);
        },
        [setActiveTab, toggleStatusFilter, active, setActive]
    );

    const toggleCalendar = useCallback(
        (value) => {
            setActiveTab(value);
        },
        [setActiveTab]
    );

    const checkRole = (panel) => {
        const permissions = [
            { panel: 'materials_admin', roles: ['owner', 'coordinator'] },
        ];
        let result = false;
        // eslint-disable-next-line
        permissions.map((permission) => {
            if (permission.panel === panel) {
                // eslint-disable-next-line
                permission.roles.map((item) => {
                    if (item === role.replace(new RegExp('"', 'g'), '')) {
                        result = true;
                    }
                });
            }
        });

        return result;
    };

    return (
        <Fragment>
            <CSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <GroupTitle
                    heading={group.title}
                    subheading={group.description}
                    organization={group.organization}
                    icon="pe-7s-users fontWeigth800"
                    role={JSON.parse(role)}
                    groupId={groupId.id}
                    triggerLogCall={triggerLogCall}
                    setTriggerLogCall={setTriggerLogCall}
                    triggerLogCallEvent={triggerLogCallEvent}
                    setTriggerLogCallEvent={setTriggerLogCallEvent}
                    allPlans={allPlans}
                    showLogs={true}
                    setRefreshNeed={setRefreshNeed}
                />
            </CSSTransitionGroup>

            <CSSTransitionGroup
                className={cx('app-inner-layout chat-layout', {
                    'open-mobile-menu': active,
                })}
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}
            >
                <div>
                    <div className="app-inner-layout__wrapper row-fluid no-gutters">
                        <Card className="app-inner-layout__sidebar bg-transparent">
                            <div className="p-3">
                                <div className="dropdown-menu p-0 dropdown-menu-inline dropdown-menu-rounded dropdown-menu-hover-primary">
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '5',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('5');
                                        }}
                                    >
                                        Group Info
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '1',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('1');
                                        }}
                                    >
                                        Coordinators
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '3',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('3');
                                        }}
                                    >
                                        Seniors
                                    </Button>

                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '4',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('4');
                                        }}
                                    >
                                        Schedule
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '7',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('7');
                                        }}
                                    >
                                        Needs
                                    </Button>
                                    <Button
                                        color="primary"
                                        className={classnames(
                                            'mb-1 dropdown-item',
                                            {
                                                active: activeTab === '9',
                                            }
                                        )}
                                        onClick={() => {
                                            toggle('9');
                                        }}
                                    >
                                        Resources
                                    </Button>
                                </div>
                            </div>
                        </Card>
                        <Card className="col-md-12 app-inner-layout__content">
                            <div className="pb-5 pl-2 pr-2 pt-3">
                                <div className="mobile-app-menu-btn mb-3">
                                    <Elastic
                                        width={26}
                                        lineHeight={2}
                                        lineSpacing={5}
                                        color="#6c757d"
                                        active={active}
                                        onClick={() => setActive(!active)}
                                    />
                                </div>

                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="3">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>My Seniors {seniorsCount && `(${seniorsCount})`}</h4>
                                            </Col>
                                        </Row>
                                        <div className="divider" />
                                        <Receivers
                                            id={groupId}
                                            activeTab={activeTab}
                                            filter={currentStatusFilter}
                                            role={role}
                                            setActiveTab={setActiveTab}
                                            changeSeniorCountCallBack={setSeniorsCount}
                                        />
                                    </TabPane>

                                    <TabPane tabId="4">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>My Calendar</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <Button
                                                    className="mb-2 mr-2 btn-icon btn-icon-only"
                                                    color="success"
                                                    onClick={() =>
                                                        toggleCalendar('41')
                                                    }
                                                    id="callPlanId"
                                                >
                                                    Call Plan
                                                </Button>
                                                <UncontrolledTooltip
                                                    placement="left"
                                                    target={'callPlanId'}
                                                >
                                                    View My Call Plan
                                                </UncontrolledTooltip>
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <Calendar
                                            receivers={receivers}
                                            role={JSON.parse(role)}
                                            setTriggerLogCall={setTriggerLogCallEvent}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="41">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>My Call Plan</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <Button
                                                    className="mb-2 mr-2 btn-icon btn-icon-only"
                                                    color="success"
                                                    onClick={() =>
                                                        toggleCalendar('4')
                                                    }
                                                    id="calendarId"
                                                >
                                                    Calendar
                                                </Button>
                                                <UncontrolledTooltip
                                                    placement="left"
                                                    target={'calendarId'}
                                                >
                                                    View My Calendar
                                                </UncontrolledTooltip>
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <GiftsList
                                            receivers={receivers}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="5">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Group Info</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <ButtonGroupTopActions
                                                    showRefreshBtn={true}
                                                    showAddBtn={false}
                                                    refreshCallback={getGroup}
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <GroupInfo
                                            group={group}
                                            admin={checkRole(
                                                'group_info_admin'
                                            )}
                                            owner={checkRole('transfer_group')}
                                        />

                                        <MaterialsList
                                            id={groupId}
                                            admin={checkRole('materials_admin')}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="7">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Needs</h4>
                                            </Col>
                                            <Col sm={4} className="text-right">
                                                <AddNeeds
                                                    id={groupId}
                                                    receivers={receivers}
                                                    setRefreshNeed={setRefreshNeed}
                                                />
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <Needs
                                            receivers={receivers}
                                            role={JSON.parse(role)}
                                            refreshNeed={refreshNeed}
                                            setRefreshNeed={setRefreshNeed}
                                        />

                                        <div className="mt-5" />
                                    </TabPane>

                                    <TabPane tabId="1">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Coordinators</h4>
                                            </Col>
                                        </Row>
                                        <div className="divider" />
                                        <Coordinators
                                            id={groupId}
                                            activeTab={activeTab}
                                            filter={currentStatusFilter}
                                            newUser={newUser}
                                        />
                                    </TabPane>

                                    <TabPane tabId="9">
                                        <Row className="pl-3 pr-3">
                                            <Col sm={8}>
                                                <h4>Resources</h4>
                                            </Col>
                                        </Row>
                                        <div className="divider" />

                                        <Resources />

                                    </TabPane>

                                </TabContent>
                            </div>
                        </Card>
                    </div>
                </div>
            </CSSTransitionGroup>
        </Fragment>
    );
}
